import ArrowLeft from '@assets/icons/arrow-left.svg'
import { Icon } from './Icon'

export const ArrowLeftIcon = Icon(ArrowLeft)
